import clientImg from "../../assets/images/deliveryMarker.svg";
import storeImg1 from "../../assets/images/storeMarker.svg";
import storeImg2 from "../../assets/images/storeMarker 2.svg";
export const POINT = "Point";
export const MULTI_PINTS = "p";
export const POLYNGO = "s";

export interface ICenter {
  lat: number;
  lng: number;
}

export const getImageByType = (type: number) => {
  switch (type) {
    case 1:
      return storeImg2;
    case 2:
      return storeImg1;
    case 3:
      return clientImg;
    default:
      return storeImg1;
  }
};
